import React from 'react';
import { Typography, Paper, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const DashboardFAQ = () => {
  const faqs = [
    {
      question: "How often is the Dashboard updated?",
      answer: "The Dashboard is updated in real-time. Most metrics and analytics are refreshed instantly as new data becomes available. However, some more complex analytics might have a slight delay, typically no more than a few minutes."
    },
    {
      question: "Can I customize the Dashboard layout?",
      answer: "Yes, the Dashboard is highly customizable. You can rearrange widgets, add or remove metrics, and create custom views tailored to your specific needs. To customize your Dashboard, click on the 'Customize' button in the top right corner of the Dashboard page."
    },
    {
      question: "How far back can I view historical data?",
      answer: "By default, the Dashboard displays data from the past 30 days. However, you can access historical data going back up to 12 months. For longer-term data storage and analysis, please contact our support team to discuss extended data retention options."
    },
    {
      question: "Can I export data from the Dashboard?",
      answer: "Yes, you can export data from various sections of the Dashboard. Look for the 'Export' button, typically represented by a download icon, in each widget or section. You can export data in various formats including CSV, PDF, and Excel."
    },
    {
      question: "How do I set up alerts for specific metrics?",
      answer: "To set up alerts, navigate to the 'Alerts' section in your Dashboard settings. Here, you can create custom alerts for any metric. Specify the conditions that should trigger an alert and choose how you want to be notified (email, SMS, or in-app notification)."
    },
    {
      question: "Can multiple team members access the Dashboard?",
      answer: "Yes, multiple team members can access the Dashboard. Access is controlled through user permissions set by your account administrator. Different team members can be granted various levels of access, from view-only to full administrative rights."
    },
    {
      question: "How can I compare performance across different time periods?",
      answer: "The Dashboard includes a date range selector that allows you to compare data across different time periods. Select 'Compare' in the date range picker and choose the periods you want to compare. The Dashboard will then display comparative data for these periods."
    },
    {
      question: "Is there a mobile version of the Dashboard?",
      answer: "Yes, we offer a mobile-responsive version of the Dashboard that you can access through your smartphone or tablet's web browser. We also have dedicated mobile apps for iOS and Android that provide a streamlined Dashboard experience optimized for mobile devices."
    }
  ];

  return (
    <Paper elevation={0}>
      <Typography variant="h4" gutterBottom>Dashboard FAQ</Typography>
      <Typography paragraph>
        Here are some frequently asked questions about the AI Talker Dashboard. If you can't find the answer you're looking for, please don't hesitate to contact our support team.
      </Typography>
      {faqs.map((faq, index) => (
        <Accordion key={index}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`panel${index}a-content`}
            id={`panel${index}a-header`}
          >
            <Typography>{faq.question}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              {faq.answer}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
      <Typography paragraph style={{ marginTop: '20px' }}>
        If you have any other questions or need further assistance with your Dashboard, our support team is always here to help. You can reach us through the 'Help' section in your Dashboard or by emailing support@aitalker.com.
      </Typography>
    </Paper>
  );
};

export default DashboardFAQ;
